import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import axios from './axios';
import $i18n from './i18n';
const i18n: any = $i18n.global;
import VueGtm from 'vue-gtm';

const Components = require('@peanuts/vue-falbala-components');

const app = createApp(App);

Object.keys(Components.default).forEach(name => {
  app.component(name, Components.default[name]);
});

app
  .use(store)
  .use(router)
  .use($i18n)
  .use(axios)
  .use(VueGtm, {
    id: ['GTM-PNSLQPN', 'GTM-NRG8XR'],
    enabled: true,
    debug: true,
    loadScript: false,
    vueRouter: router
});

app.config.warnHandler = (msg, vm, trace) => null;

// get version from package.json
let appVersion = require('./../package.json').version;

// remove last digit from version string, eg 66.0.0 -> 66.0.
if(appVersion.length>1) {
  appVersion = appVersion.substring(0, appVersion.length - 1)
}

let buildNumber = process.env.VUE_APP_BAMBOO_BUILD_NUMBER;


if(!buildNumber) {
  buildNumber = 0;
}

let completeAppVersion = appVersion + buildNumber;

store.commit("initializeStore");
store.commit('setAppVersion', completeAppVersion);


router.beforeEach(function (to, from, next) {

  if (!store.state.userDetail) {
    // customers with null userDetail are not logged in, if they want to reach protected area, send them to login screen
    if (to.path.startsWith('/protected')) {
      store.commit("setWarningMessage", i18n.t('COMMON.ERROR_MESSAGES.NOT_LOGGED_IN'));
      store.commit("setLoginRedirectName", to.name);
      next({path: 'login'});
    } else {
      next();
    }
  } else {
    // customers who are logged in can't reach landing page
    if (to.path.endsWith('/')) {
      if ( from.path == "/" ) {
        next({ name: 'manage'});
      } else {
        next(false);
      }
    } else {
      next();
    }
  }
});

app.mount('#app');
